/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".slds-input.ng-dirty.ng-valid,.slds-select.ng-dirty.ng-valid,.slds-textarea.ng-dirty.ng-valid{color:#027e46}.slds-input.ng-dirty,.slds-select.ng-dirty,.slds-textarea.ng-dirty{background:#faffbd}"];
export { styles as styles };
